module.exports = __webpack_public_path__ + "static/media/icon_edit.4dbf96fd.svg";